import { Alert, Spinner } from 'react-bootstrap'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../../store/hooks'
import { useGetAllServiceLocationsQuery } from '../../../../../store/user/user'
import { IntegrationServiceId } from '../../../../../common/integrations'
import { ContactCardSelector } from '../../../../../components/ContactCardSelector/ContactCardSelector'

export const PhoneLocationSettings: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: locations, isFetching: locationsFetching } = useGetAllServiceLocationsQuery({
    accountId: accountId,
    serviceId: IntegrationServiceId.PHONE,
  })

  if (locationsFetching) {
    return (
      <div className='d-flex justify-content-center'>
        <Spinner />
      </div>
    )
  }

  if (locations?.data.length) {
    return <ContactCardSelector locations={locations.data} />
  }

  return (
    <Alert variant='danger'>
      <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
      <p>Unable to get any locations. Please contact us.</p>
    </Alert>
  )
}
